import {getDefaultConfig, makeResponseSafe} from '@utils/omicron';

import {
  OmicronConfigSchema,
  type OmicronConfigType,
  type OmicronResponse,
} from './omicron.entity';

export const omicronFallback: OmicronResponse = {
  config: getDefaultConfig<OmicronConfigType>(OmicronConfigSchema),
};

export const fetchOmicron = async (): Promise<OmicronResponse> => {
  try {
    const url = process.env.PUBLIC_OMICRON_URL;
    const configId = process.env.PUBLIC_OMICRON_URL_CONFIG_ID as string;
    const env = process.env.PUBLIC_OMICRON_URL_ENV as string;
    const params = new URLSearchParams({config_id: configId, env});

    const response = await fetch(`${url}/omicron/config?${params.toString()}`, {
      cache: 'no-cache',
    });

    if (!response.ok) {
      console.warn(`fetchOmicron: bad status = ${response.status}`);

      return omicronFallback;
    }

    const json = await response.json();

    return makeResponseSafe<OmicronConfigType>(OmicronConfigSchema, json);
  } catch (e) {
    console.warn(`fetchOmicron: exception`, e);

    return omicronFallback;
  }
};
